<div class="assignments-page p-fluid">
    <app-page-shell>
        <p-toast></p-toast>
        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


        <app-page-hero eyebrow="CRM Sales Ownership" title="Sales Assignments" subtitle="Manage each client primary Salesman/KAM and supporting sales team members.">
            <div actions>
                <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadOptionsAndAssignments()"></p-button>
                <p-button label="New Assignment" icon="pi pi-plus" (click)="openNew()"></p-button>
            </div>
        </app-page-hero>

        <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

        <app-page-search-panel title="Search Assignments" [activeFilters]="activeSearchCount" [collapsed]="true" (clear)="clearSearch()" (search)="applySearch()">
            <div class="search-grid">
                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="assignmentGlobalSearch" pInputText [value]="searchText()" (input)="searchText.set($any($event.target).value)" (keydown.enter)="applySearch()">
                            <label for="assignmentGlobalSearch">Global Search</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select inputId="assignmentClientSearch" [options]="clientOptions()" optionLabel="label" optionValue="value" [ngModel]="clientPartyFilter()" (ngModelChange)="clientPartyFilter.set($event)" [showClear]="true" styleClass="w-full"></p-select>
                            <label for="assignmentClientSearch">Client</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select inputId="assignmentEmployeeSearch" [options]="employeeOptions()" optionLabel="label" optionValue="value" [ngModel]="employeePartyFilter()" (ngModelChange)="employeePartyFilter.set($event)" [showClear]="true" styleClass="w-full"></p-select>
                            <label for="assignmentEmployeeSearch">Employee</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-star"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select inputId="assignmentOwnerSearch" [options]="ownerOptions" optionLabel="label" optionValue="value" [ngModel]="ownerFilter()" (ngModelChange)="ownerFilter.set($event)" [showClear]="true" styleClass="w-full"></p-select>
                            <label for="assignmentOwnerSearch">Ownership</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-circle"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select inputId="assignmentActiveSearch" [options]="activeOptions" optionLabel="label" optionValue="value" [ngModel]="activeFilter()" (ngModelChange)="activeFilter.set($event)" [showClear]="true" styleClass="w-full"></p-select>
                            <label for="assignmentActiveSearch">Status</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
            </div>
        </app-page-search-panel>

        <app-page-data-panel title="Ownership Directory" [subtitle]="lastUpdatedText" [resultText]="rows().length + ' client records'">
            <p-table
                [value]="rows()"
                [rows]="10"
                [paginator]="true"
                [loading]="loading()"
                [rowHover]="true"
                dataKey="clientPartyId"
                styleClass="p-datatable-sm p-datatable-gridlines assignments-data-table"
                [tableStyle]="{ 'min-width': '64rem' }"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} client assignments"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Client</th>
                        <th>Primary Owner</th>
                        <th>Team</th>
                        <th>Updates</th>
                        <th class="text-center" style="width: 8rem">Actions</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td>
                            <div class="stack-cell">
                                @if (row.crmClientId) {
                                    <a class="link-button cell-title" [routerLink]="['/crm/clients', row.crmClientId]">{{ row.clientName }}</a>
                                } @else {
                                    <span class="cell-title">{{ row.clientName }}</span>
                                }
                                <div class="cell-meta">
                                    <span><i class="pi pi-briefcase"></i>{{ row.businessType || 'Business n/a' }}</span>
                                    <span><i class="pi pi-tags"></i>{{ row.segment || 'Segment n/a' }}</span>
                                </div>
                            </div>
                        </td>

                        <td>
                            <div class="stack-cell">
                                <span class="cell-title">{{ row.primary?.employeeParty?.entityName || 'Unassigned' }}</span>
                                <div class="cell-meta">
                                    <p-tag [value]="row.primary ? 'Primary' : 'Missing Primary'" [severity]="row.primary ? 'success' : 'warn'"></p-tag>
                                    @if (row.primary?.active === false) {
                                        <p-tag value="Inactive" severity="secondary"></p-tag>
                                    }
                                </div>
                            </div>
                        </td>

                        <td>
                            <div class="stack-cell">
                                <span class="quality-pill">{{ row.team.length }} team member{{ row.team.length === 1 ? '' : 's' }}</span>
                                <div class="cell-meta vertical">
                                    @for (member of row.team.slice(0, 3); track member.id) {
                                        <span><i class="pi pi-user"></i>{{ member.employeeParty?.entityName || '-' }}</span>
                                    }
                                    @if (row.team.length > 3) {
                                        <span><i class="pi pi-ellipsis-h"></i>{{ row.team.length - 3 }} more</span>
                                    }
                                </div>
                            </div>
                        </td>

                        <td>
                            <div class="stack-cell">
                                <span class="cell-title">{{ row.all[0]?.updatedByCustomerName || row.all[0]?.createdByCustomerName || '-' }}</span>
                                <div class="cell-meta vertical">
                                    <span><i class="pi pi-calendar"></i>{{ row.updatedAt ? (row.updatedAt | date:'medium') : (row.createdAt | date:'medium') }}</span>
                                    <span><i class="pi pi-check-circle"></i>{{ row.all[0]?.active === false ? 'Inactive' : 'Active' }}</span>
                                </div>
                            </div>
                        </td>

                        <td class="text-center">
                            <div class="row-actions">
                                <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-text p-button-info" [disabled]="!row.crmClientId" (click)="viewClient(row)" pTooltip="View Client"></button>
                                <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary" (click)="editAssignment(row)" pTooltip="Edit Assignment"></button>
                                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" (click)="deleteAssignment(row)" pTooltip="Delete Assignments"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5">
                            <div class="empty-state">
                                <i class="pi pi-users"></i>
                                <strong>No sales assignments found</strong>
                                <span>Assign a primary Salesman/KAM to begin ownership tracking.</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    </app-page-shell>
</div>

<p-dialog
    [visible]="assignmentDialog()"
    (visibleChange)="assignmentDialog.set($event)"
    [style]="{width: '680px'}"
    header="Sales Assignment"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="assignmentForm" class="assignment-form">
            <div class="form-grid">
                <div class="field col-span-2">
                    <p-iftaLabel>
                        <p-select inputId="clientPartyId" formControlName="clientPartyId" [options]="clientOptions()" optionLabel="label" optionValue="value" [filter]="true" styleClass="w-full"></p-select>
                        <label for="clientPartyId">Client</label>
                    </p-iftaLabel>
                    <small class="p-error block mt-1" *ngIf="submitted() && assignmentForm.get('clientPartyId')?.invalid">Client is required.</small>
                </div>

                <div class="field">
                    <p-iftaLabel>
                        <p-select inputId="primaryEmployeePartyId" formControlName="primaryEmployeePartyId" [options]="employeeOptions()" optionLabel="label" optionValue="value" [filter]="true" styleClass="w-full"></p-select>
                        <label for="primaryEmployeePartyId">Primary Salesman / KAM</label>
                    </p-iftaLabel>
                    <small class="p-error block mt-1" *ngIf="submitted() && assignmentForm.get('primaryEmployeePartyId')?.invalid">Primary owner is required.</small>
                </div>

                <div class="field">
                    <p-iftaLabel>
                        <p-select inputId="assignmentRole" formControlName="assignmentRole" [options]="roleOptions" optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
                        <label for="assignmentRole">Team Role</label>
                    </p-iftaLabel>
                </div>

                <div class="field col-span-2">
                    <p-iftaLabel>
                        <p-multiSelect inputId="teamEmployeePartyIds" formControlName="teamEmployeePartyIds" [options]="employeeOptions()" optionLabel="label" optionValue="value" [filter]="true" display="chip" styleClass="w-full"></p-multiSelect>
                        <label for="teamEmployeePartyIds">Team Members</label>
                    </p-iftaLabel>
                </div>

                <div class="field checkbox-field">
                    <p-checkbox inputId="assignmentActive" formControlName="active" [binary]="true"></p-checkbox>
                    <label for="assignmentActive">Active assignment</label>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" [text]="true" (click)="hideDialog()"></p-button>
        <p-button label="Save Assignment" icon="pi pi-check" (click)="saveAssignment()" [loading]="saving()" [disabled]="saving()"></p-button>
    </ng-template>
</p-dialog>
